import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import ru from "./ru.json";
import en from "./en.json";
import tr from "./tr.json";

export const SUPPORTED_LANGS = ["ru", "en", "tr"] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

const DEFAULT_LANG: Lang = "ru";

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			ru: { translation: ru },
			en: { translation: en },
			tr: { translation: tr },
		},
		fallbackLng: DEFAULT_LANG,
		supportedLngs: [...SUPPORTED_LANGS],
		defaultNS: "translation",
		ns: ["translation"],
		interpolation: { escapeValue: false },
		react: { useSuspense: true },

		// keep language between reloads
		detection: {
			order: ["localStorage", "navigator"],
			caches: ["localStorage"],
			lookupLocalStorage: "app.lang",
		},
	});

export default i18n;

export const changeLanguage = async (lng: Lang) => {
	await i18n.changeLanguage(lng);
};
